(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/routers/router-base.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/routers/router-base.js');

'use strict';

svs.matchen.RouterBase = Backbone.Router.extend({
  routes: svs.core.data.routes,

  start: function(tab) {
    svs.matchen.collections.draws = new svs.matchen.collections.Draws(
      svs.matchen.data.draws,
      { parse: true }
    );

    var drawsCollection = svs.matchen.collections.draws;
    var startPageHandler = new svs.matchen.objects.StartPageHandler({
      links: svs.matchen.app.config.getLinks(),
      tabs: svs.matchen.app.config.getTabs(),
      hotDraws: svs.matchen.app.config.getHotDraws(),
      branding: 'oddset',
      backgroundImageURL: svs.matchen.app.config.getBackgroundImageURL(),
      draws: drawsCollection
    });

    $('body').addClass('matchen-start');

    this.onAfterStartPageInitialized(startPageHandler); 

    if (svs.matchen.data.gameguide != undefined) {
      Backbone.history.navigate('/', { trigger: false, replace: true });
      svs.matchen.utils.showGameGuide(svs.matchen.data.gameguide);
      delete svs.matchen.data.gameguide;
    }

    svs.core.data.title = { tab: tab };
  },

  getNormalizedMatch: function(match, draw) {
    match = match || {};
    match.sport = _.clone(draw.get('sport'));
    match.league = match.league || {}; 
    match.league.sport = _.clone(draw.get('sport'));

    return match;
  },

  checkValidTab: function(tab, draws) {
    var isValid = _.contains(
      draws.getUniqueDrawDays(),
      tab && tab.toLowerCase()
    );

    if (!isValid) {
      Backbone.history.navigate('/', { trigger: false, replace: true });
      svs.components.Storage.browser.remove('tab', 'Matchen');
    }

    return isValid;
  },

  saveTab: function(tab) {
    svs.components.Storage.browser.set('tab', 'Matchen', tab);
    svs.core.data.title = { tab: tab };
  }
});


 })(window);